import { routes } from "src/config/routes"
import { SanityAnnouncementData } from "src/data/sanity/types"
import { NpDiscountPill } from "../../components/NpDiscountPill"
import { NpHeaderTextLink } from "./NpHeaderTextLink"

export type NpHeaderTextLinksProps = {
  announcement?: SanityAnnouncementData | null
}

export const NpHeaderTextLinks = ({ announcement }: NpHeaderTextLinksProps) => {
  return (
    <>
      <NpHeaderTextLink href={routes.bollerwagen}>Bollerwagen</NpHeaderTextLink>
      <NpHeaderTextLink href={routes.laufraeder}>Laufrad</NpHeaderTextLink>
      <NpHeaderTextLink href={routes.scooter}>Scooter</NpHeaderTextLink>
      <NpHeaderTextLink href={routes.federwiegen}>Federwiege</NpHeaderTextLink>
      <NpHeaderTextLink href={routes.bStock}>B-Ware</NpHeaderTextLink>
      <NpHeaderTextLink href={routes.accessories}>Zubehör</NpHeaderTextLink>
      <NpHeaderTextLink href={routes.spareParts}>Ersatzteile</NpHeaderTextLink>

      {announcement && (
        <NpHeaderTextLink href={announcement.href}>
          <span>{announcement.shortText}</span>{" "}
          {announcement.discountAmount && <NpDiscountPill>{announcement.discountAmount}</NpDiscountPill>}
        </NpHeaderTextLink>
      )}
    </>
  )
}
